import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-vue-share",
  "use": "foquz-icon-vue-share-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol preserveAspectRatio=\"none\" overflow=\"visible\" viewBox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-vue-share\"><path d=\"M6 13H2.333A1.334 1.334 0 011 11.667V2.333A1.333 1.333 0 012.333 1H6m3.667 9.333L13 7m0 0L9.667 3.667M13 7H5\" stroke=\"var(--stroke-0, #667799)\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol